class ProductThumbCarousel extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.thumbs = this.querySelectorAll(".carousel--block--container .product-media--root");
		this.clickListener();
    }
    clickListener() {
        this.thumbs.on("keypress click", ({ target: t, currentTarget: ct }) => {
			var e = parseInt(ct.dataset.id);
			const oldActive = document.querySelector( '.product-media--variants .product-media--root[data-active="true"]' );
			const newActive = document.querySelector( '.product-media--variants .product-media--root[data-id="' + e + '"]' );
			oldActive.dataset.active = false;
			newActive.dataset.active = true;
        });
    }
}
const productThumbCarouselEl = customElements.get("product-thumb-carousel");
productThumbCarouselEl || customElements.define("product-thumb-carousel", ProductThumbCarousel);